// Few utilities helpers

import moment from 'moment';
import 'moment/locale/en-gb';

const pluralizer = (size, text) => (
  (size === 1) ? `${size} ${text}` : `${size} ${text}s`
);

const localDateFormat = (date) => {
  const locale = window.navigator.userLanguage || window.navigator.language;
  moment.locale(locale.toLowerCase());
  return moment(date).format('L');
};

export { pluralizer, localDateFormat };
